<template>
  <article class="px-0 py-0 my-0">
    <section class="section-daten-liefern px-7 px-xl-9 m-0">
      <div style="max-width:1280px" class="mx-auto">
        <h1 class="by-heading-2 text-by-blue-100 mb-5">Open Data Day München 2024</h1>
        <div class="introduction-container">
          <p class="restrict-max-width mb-0 by-copy-large-semibold text-by-neutral-100">Einen Tag lang eintauchen in die Welt der
          offenen Daten - ein Treffen von Open Data Communities aus Zivilgesellschaft, Wissenschaft, Wirtschaft und der Verwaltung.
          </p>
          <p class="d-flex flex-row align-items-center restrict-max-width mb-0 by-copy-small-regular text-by-neutral-100">
            Wann? 04.05.2024 09:00-17:00
            <br>
            Einlass? Ab 08:30 Uhr
            <br>
            Wo? Munich Urban Colab, Freddie-Mercury-Straße 5, 80797 München
          </p>
        </div>
      </div>
    </section>
    <section class="m-0 pb-10 bg-by-neutral-10">
      <div
        class="mb-9" style="text-align: center;">
        <img class="embed-responsive-item" aria-hidden="true"
             src="../assets/img/odd24_fullwidth.png" alt="Ankündigungsposter für den Open Data Day München 2024. Dunkler Hintergrund mit isometrischen Würfeln in verschiedenen Farben und dem Datum 4. Mai 2024." style="max-width:1280px; width: 100%;" />
      </div>
      <div class="px-7 px-xl-9">
        <div class="row mx-auto" style="max-width: 1280px;">
          <div class="px-0 pr-md-3 col-xs-12 col-md-4 col-lg-4 mb-7">
            <p class="by-copy-large-semibold text-by-blue-100 mb-2">Wer ist dabei?</p>
            <p class="by-copy-small-regular text-by-neutral-60 m-0">
              Veranstaltet wird das Event von der Landeshauptstadt München und der Bayerischen Digitalagentur byte zusammen mit dem 
              OK Lab München. Datenbegeisterte aus Zivilgesellschaft und Wissenschaft, aber auch der Wirtschaft und der Verwaltung selbst sind eingeladen.
            </p>
          </div>
          <div class="px-0 pl-md-3 px-xl-3 col-xs-12 col-md-4 col-lg-4 mb-7">
            <p class="by-copy-large-semibold text-by-blue-100 mb-2">Was machen wir?</p>
            <p class="by-copy-small-regular text-by-neutral-60 m-0">
              Den ganzen Tag werden Vorträge und Workshops stattfinden, die Impulse und Einblicke in die facettenreiche Welt der Daten geben.
              Es warten spezielle Angebote zum Kennenlernen, Vernetzen und Austauschen auf die Teilnehmenden.
            </p>
          </div>
          <div class="px-0 pr-md-3 px-xl-3 col-xs-12 col-md-4 col-lg-4 mb-7">
            <p class="by-copy-large-semibold text-by-blue-100 mb-2">Wie kann ich mitmachen?</p>
            <p class="by-copy-small-regular text-by-neutral-60 m-0">
              Die Anmeldung ist natürlich kostenlos - gleich jetzt <a href="https://veranstaltungen.muenchen.de/rit/veranstaltungen/open-data-day-muenchen-2024/">anmelden</a> und einen Platz sichern! Bei Fragen oder Anregungen vorab freuen wir
              uns auf einen Austausch unter <a href="mailto:openbydata@byte.bayern">openbydata@byte.bayern</a>.
            </p>
          </div>
        </div>
      </div>
    </section>
    <section class="section-daten-liefern px-7 px-xl-9 m-0">
      <div style="max-width:1280px" class="mx-auto">
        <h1 class="by-heading-2 text-by-blue-100 mb-5">Was steht auf dem Programm?</h1>
        <div class="introduction-container">
          <p class="restrict-max-width mb-0 by-copy-large-semibold text-by-neutral-100">Neben spannenden Eröffnungsvorträgen und Networking-Möglichkeiten wird es 3 Workshop-Slots á 60 Minuten in bis zu vier Räumen geben. Hier eine Vorschau auf die Workshop-Themen – Änderungen vorbehalten:
          </p>
          <ul>
            <li>Bayern #openbydata machen, gemeinsam Netzwerke schaffen</li>
            <li>Open Data in 60 Minuten</li>
            <li>Open Science: Sensitive Gesundheitsdaten - Was ist für die Wissenschaft von  Interesse, und wie geht sie damit um</li>
            <li>City API – Einführung in API Gateways oder ‚Wie baut man einen Knowledge Graph‘</li>
            <li>Linked Open Data für Verwaltung: Eine Einführung</li>
            <li>Sprachassistenten für offene Daten erstellen</li>
            <li>Open Data in der Kultur: Was können wir vom Kultur-Hackathon Coding da Vinci lernen?</li>
            <li>Open Data Best Practices aus der Start-up-Welt: Chancen und Herausforderungen</li>
            <li>Die Möglichkeiten von Piveau – wie eine Open Source Community hinter Piveau aussehen kann</li>
            <li>Open Data Best Practices aus der Zivilgesellschaft für die Gestaltung von Smart Cities: Chancen erkennen und Potentiale entfalten</li>
            <li>Open Data Bad Practices - Vermeidbare Fehler bei der Verwaltungsdigitalisierung</li>
          </ul>
          <p class="by-copy-small-regular text-by-neutral-60 m-0">Jetzt schon <a href="https://veranstaltungen.muenchen.de/rit/veranstaltungen/open-data-day-muenchen-2024/">anmelden</a> und einen Platz sichern!
          </p>
        </div>
      </div>
    </section>
    <section class="m-0 pt-9 pb-11 px-7 px-xl-9 pb-9 bg-by-neutral-5">
      <div style="max-width:1280px" class="mx-auto text-center">
        <h4 class="by-heading-4 text-by-blue-100 mb-5">Fragen oder Anregungen?</h4>
        <p class="by-heading-4 text-by-neutral-60 mb-7 d-md-none">
          "Kommt auf uns zu, wir freuen uns auf jeden Austausch rund um Open Data!"
        </p>
        <img src="../assets/img/bianca_sammer.jpg" class="mb-2 d-md-none"
             style="border-radius: 6rem; width: 6rem; height: 6rem;"/>
        <img src="../assets/img/bianca_sammer.jpg" class="mb-2 d-none d-md-inline d-xl-none"
             style="border-radius: 7.5rem; width: 7.5rem; height: 7.5rem;"/>
        <img src="../assets/img/bianca_sammer.jpg" class="mb-2 d-none d-xl-inline"
             style="border-radius: 10rem; width: 10rem; height: 10rem;"/>
        <p class="by-copy-small-semibold text-by-neutral-100 mb-0">
          Bianca Sammer
        </p>
        <p class="by-copy-small-regular text-by-neutral-100 mb-4">
          Data Community Managerin für Open Data
        </p>
        <div class="d-inline-block">
          <a href="mailto:openbydata@byte.bayern "
             class="by-btn-primary-large-light mt-7 btn-mail">
            Eine Nachricht schreiben</a>
        </div>
      </div>
    </section>
  </article>
</template>
<style lang="scss" scoped>
.btn-mail {
  display: flex;
  padding: 11px 1.5rem;
  align-items: center;
  background-color: var(--by-neutral-5);
  color: var(--by-neutral-100);

  &::before {
    color: white;
    content: '';
    width: 24px;
    height: 24px;
    margin-right: .5rem;
    background: url('../assets/icon/icon-envelope.svg') no-repeat;
  }
}

.btn-login {
  &::after {
    content: '';
    width: 24px;
    height: 24px;
    margin-left: .5rem;
    background: url('../assets/icon/icon-caretright.svg') no-repeat;
  }
}

.introduction-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.section-daten-liefern {
  padding-top: 8.5rem;
  padding-bottom: 8.5rem;
}
</style>
<style>
.custom-article-truncate {
  display: -webkit-box;
  -webkit-line-clamp: 4; /* Number of lines to display */
  line-clamp: 4; /* Number of lines to display */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.embed-responsive-2by1::before {
  content: "";
  padding-top: 50%
}
</style>
<script>
export default {
  name: "Odd24",
  metaInfo() {
    const title = "Open Data Day München 2024 - open bydata";
    return {
      titleTemplate(chunk) {
        return title;
      },
    };
  },
  methods: {
    login() {
      if (!this.$keycloak) {
        console.error("Keycloak not initialized!");
        return;
      }
      
      this.$keycloak.loginFn();
    },
  }
}
</script>
